import { Record } from 'immutable';
const ErrorMessageTokens = Record({
  bouncedEmailAddress: null,
  enforcedSubscriptionType: null
}, 'ErrorMessageTokens');
export default ErrorMessageTokens;